import {
    SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA,
    SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA, SET_DISCOUNT_FLAG, SET_UPDATED_BY_ACQUISITION_LIST
} from './AcquisitionCodeMaintenanceType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA:
            return {
                ...state,
                acquisitionCodeMaintenanceGridData: action.gridData,
            };
        case SET_UPDATED_BY_ACQUISITION_LIST:
            return {
                ...state,
                updatedByDropdownList: action.dropdownList,
            };
        case SET_DISCOUNT_FLAG:
            return {
                ...state,
                isDiscountFlag: action.flag
            };
        case SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA:
            return {
                ...state,
                acquisitionCodeMaintenanceExcelData: action.excelData
            };
        default:
            return state;
    }
}

export {
    reducers
}